export default function () {
  for (var n = arguments.length, r = new Array(n), t = 0; t < n; t++) {
    r[t] = arguments[t];
  }

  return function (n) {
    r.forEach(function (r) {
      "function" == typeof r ? r(n) : null != r && (r.current = n);
    });
  };
}